import React, { useState, useEffect } from "react";

import { useDispatch, useSelector } from "react-redux";
import { loadSettings, postSettings, getBoxSettings } from "../../../../../redux/actions/config/box/settings";
import { loadBoxUsers, addBoxUser, deleteBoxUser, getBoxUsers } from "../../../../../redux/actions/config/box/user";

/* Form & Form Validation */
import * as Yup from "yup";
import { isNotValid, translateSymfonyErrorToFormik } from "../../../../../core/utils/form";
import { BasicForm } from "../../../../../core/components/form";
import { Form, Input } from "formik-antd";
import { flashSuccess, flashError } from "../../../../../core/utils/flashMessage";

import { Row, Card, Switch, Tabs, List, Popconfirm, Col, Button, Divider } from "antd";
import { CheckCircleTwoTone, CloseCircleTwoTone, PlusOutlined } from "@ant-design/icons";

import { Formik } from "formik";

const { TabPane } = Tabs;

const BoxSchema = Yup.object().shape({
    box_client_id: Yup.string().required("Cannot be blank."),
    box_client_secret: Yup.string().required("Cannot be blank."),
    box_enterprise_id: Yup.string().required("Cannot be blank."),
});

const BoxUserSchema = Yup.object().shape({
    email: Yup.string().email("Invalid email.").required("Cannot be blank."),
});

function validateRequired(value) {
    return value ? undefined : "required";
}

const Formulario = () => {
    const [enableEdit, setEnableEdit] = useState(false);
    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(loadSettings());
        dispatch(loadBoxUsers());
    }, []);

    const box = useSelector((state) => getBoxSettings(state));
    const { data, loading, error } = box;

    const boxUsers = useSelector((state) => getBoxUsers(state));
    const { data: userData, loading: userLoading, error: userError, loaded: userLoaded } = boxUsers;

    const _initialForm = () => {
        if (box) {
            return {
                box_client_id: data?.settings?.client_id,
                box_client_secret: data?.settings?.client_secret,
                box_enterprise_id: data?.settings?.enterprise_id,
            };
        } else {
            return {
                box_client_id: "",
                box_client_secret: "",
                box_enterprise_id: "",
            };
        }
    };

    /**
     * Función que maneja el submit del formulario
     *
     * Recordar que se puede tratar de un alta o una edición
     */
    const _handleBoxSettingSubmit = (values, bag) => {
        const form = {
            ...values,
        };

        const ret = dispatch(postSettings(JSON.stringify(form)));

        ret.then((response) => {
            if (isNotValid(response)) {
                bag.setErrors(translateSymfonyErrorToFormik(response.errors.children));
            } else {
                flashSuccess({ description: "Box Integration" });
                dispatch(loadBoxUsers());
            }
            bag.setSubmitting(false);
        }).catch((e) => {
            flashError({ description: "It wasn't posibble connect to Box. Please verify the data." });
            bag.setSubmitting(false);
        });
    };

    const _handleBoxUserSubmit = (values, bag) => {
        const ret = dispatch(addBoxUser(values.email));

        ret.then((response) => {
            if (isNotValid(response)) {
                bag.setErrors(translateSymfonyErrorToFormik(response.errors.children));
            } else {
                bag.resetForm();
                flashSuccess({ description: "Box Integration" });
            }
            bag.setSubmitting(false);
        }).catch((e) => {
            flashError({ description: "Un" });
            bag.setSubmitting(false);
        });
    };

    return (
        <Card
            loading={loading && !enableEdit}
            title={
                <>
                    {" "}
                    {data?.settings?.client_id !== undefined ? (
                        <CheckCircleTwoTone style={{ fontSize: "20px" }} twoToneColor="#52c41a" />
                    ) : (
                        <CloseCircleTwoTone style={{ fontSize: "20px" }} twoToneColor="#eb2f96" />
                    )}{" "}
                    BOX Integration
                </>
            }
            extra={
                <>
                    {" "}
                    <Switch onClick={() => setEnableEdit(!enableEdit)} />
                </>
            }
        >
            {enableEdit ? (
                <Tabs type="card">
                    <TabPane tab="Settings" key="1">
                        <BasicForm
                            initialValues={_initialForm()}
                            validationSchema={BoxSchema}
                            onSubmit={_handleBoxSettingSubmit}
                            render={() => (
                                <>
                                    <Form.Item
                                        name="box_client_id"
                                        label="Client ID"
                                        required={true}
                                        validate={validateRequired}
                                    >
                                        <Input name="box_client_id" />
                                    </Form.Item>
                                    <Form.Item
                                        name="box_client_secret"
                                        label="Client Secret"
                                        required={true}
                                        validate={validateRequired}
                                    >
                                        <Input.Password name="box_client_secret" />
                                    </Form.Item>
                                    <Form.Item
                                        name="box_enterprise_id"
                                        label="Enterprise ID"
                                        required={true}
                                        validate={validateRequired}
                                    >
                                        <Input name="box_enterprise_id" />
                                    </Form.Item>
                                </>
                            )}
                        />
                    </TabPane>
                    {data?.settings?.client_id && (
                        <TabPane tab="Users " key="2">
                            <>
                                <Formik
                                    initialValues={{ email: "" }}
                                    validationSchema={BoxUserSchema}
                                    onSubmit={_handleBoxUserSubmit}
                                >
                                    {({ isSubmitting, submitForm }) => (
                                        <Form>
                                            <Row gutter={10}>
                                                <Col flex="auto">
                                                    <Form.Item name="email" label="User email" required={true}>
                                                        <Input name="email" />
                                                    </Form.Item>
                                                </Col>
                                                <Col flex="200px">
                                                    <Button
                                                        key="submit"
                                                        loading={isSubmitting}
                                                        type="primary"
                                                        onClick={submitForm}
                                                        icon={
                                                            <>
                                                                <PlusOutlined />
                                                                <Divider type="vertical" />
                                                            </>
                                                        }
                                                    >
                                                        {isSubmitting ? "One moment ..." : "Add User"}
                                                    </Button>
                                                </Col>
                                            </Row>
                                        </Form>
                                    )}
                                </Formik>
                                <List
                                    size="small"
                                    bordered
                                    dataSource={userData?.total_count > 0 ? userData.entries : []}
                                    loading={userLoading}
                                    renderItem={(item) => (
                                        <List.Item
                                            key={item.id}
                                            actions={[
                                                <Popconfirm
                                                    title="Are you sure?"
                                                    onConfirm={() => dispatch(deleteBoxUser(item.id))}
                                                    okText="Yes"
                                                    cancelText="No"
                                                >
                                                    <a>delete</a>
                                                </Popconfirm>,
                                            ]}
                                        >
                                            {item?.accessible_by?.login ||
                                                item?.invite_email + " (" + item?.status + ")"}
                                        </List.Item>
                                    )}
                                />
                            </>
                        </TabPane>
                    )}
                </Tabs>
            ) : (
                <Row justify="center">Switch to unlock and edit data.</Row>
            )}
        </Card>
    );
};
export default Formulario;
